/** @graphql cc **/

import gql from 'graphql-tag';

/*
  If you add an optional property to PageInfoFragment then you need to duplicate this query.
  See https://product-fabric.atlassian.net/browse/SCALE-4250 for more details
*/
/*
  GraphQLPageStatus comes from monolith and PTGraphQLPageStatus comes
  from cc-page-tree and they need to be separate due to a Braid bug:
  https://product-fabric.atlassian.net/browse/SCALE-4686
*/
export const PageTreeQuery = gql`
	query PageTreeQuery(
		$spaceKey: String!
		$statuses: [GraphQLPageStatus]
		$ptStatuses: [PTGraphQLPageStatus]
		$contentId: ID!
		$paginationLimit: Int
		$isSuperAdmin: Boolean!
		$isReplacePagesWithPTPageEnabled: Boolean! = false
	) {
		currentPage: ptpage(
			id: $contentId
			spaceKey: $spaceKey
			pageTree: $paginationLimit
			status: $ptStatuses
			enablePaging: true
		) {
			id
			title
			status
			createdDate(format: MILLIS) {
				value
			}
			hasChildren
			blank
			hasRestrictions @include(if: $isSuperAdmin)
			hasInheritedRestrictions @include(if: $isSuperAdmin)
			type
			subType
			links {
				webui
			}
			properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
				nodes {
					id
					key
					value
					version {
						number
					}
				}
			}
			nearestAncestors {
				pageInfo {
					hasNextPage
					endCursor
				}
				nodes {
					id
					title
					status
					createdDate(format: MILLIS) {
						value
					}
					hasChildren
					blank
					hasRestrictions @include(if: $isSuperAdmin)
					hasInheritedRestrictions @include(if: $isSuperAdmin)
					type
					subType
					links {
						webui
					}
					properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
						nodes {
							id
							key
							value
							version {
								number
							}
						}
					}
					previousSiblings {
						nodes {
							id
							title
							status
							createdDate(format: MILLIS) {
								value
							}
							hasChildren
							blank
							hasRestrictions @include(if: $isSuperAdmin)
							hasInheritedRestrictions @include(if: $isSuperAdmin)
							type
							subType
							links {
								webui
							}
							properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
								nodes {
									id
									key
									value
									version {
										number
									}
								}
							}
						}
						pageInfo {
							hasNextPage
						}
					}
					followingSiblings {
						nodes {
							id
							title
							status
							createdDate(format: MILLIS) {
								value
							}
							hasChildren
							blank
							hasRestrictions @include(if: $isSuperAdmin)
							hasInheritedRestrictions @include(if: $isSuperAdmin)
							type
							subType
							links {
								webui
							}
							properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
								nodes {
									id
									key
									value
									version {
										number
									}
								}
							}
						}
						pageInfo {
							hasNextPage
						}
					}
				}
			}
			previousSiblings {
				nodes {
					id
					title
					status
					createdDate(format: MILLIS) {
						value
					}
					hasChildren
					blank
					hasRestrictions @include(if: $isSuperAdmin)
					hasInheritedRestrictions @include(if: $isSuperAdmin)
					type
					subType
					links {
						webui
					}
					properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
						nodes {
							id
							key
							value
							version {
								number
							}
						}
					}
				}
				pageInfo {
					hasNextPage
				}
			}
			followingSiblings {
				nodes {
					id
					title
					status
					createdDate(format: MILLIS) {
						value
					}
					hasChildren
					blank
					hasRestrictions @include(if: $isSuperAdmin)
					hasInheritedRestrictions @include(if: $isSuperAdmin)
					type
					subType
					links {
						webui
					}
					properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
						nodes {
							id
							key
							value
							version {
								number
							}
						}
					}
				}
				pageInfo {
					hasNextPage
				}
			}
			children {
				nodes {
					id
					title
					status
					createdDate(format: MILLIS) {
						value
					}
					hasChildren
					blank
					hasRestrictions @include(if: $isSuperAdmin)
					hasInheritedRestrictions @include(if: $isSuperAdmin)
					type
					subType
					links {
						webui
					}
					properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
						nodes {
							id
							key
							value
							version {
								number
							}
						}
					}
				}
				pageInfo {
					hasNextPage
				}
			}
		}
		ptpage(
			spaceKey: $spaceKey
			pageTree: $paginationLimit
			status: $ptStatuses
			enablePaging: true
		) @include(if: $isReplacePagesWithPTPageEnabled) {
			id
			title
			status
			createdDate(format: MILLIS) {
				value
			}
			hasChildren
			blank
			hasRestrictions @include(if: $isSuperAdmin)
			hasInheritedRestrictions @include(if: $isSuperAdmin)
			type
			subType
			links {
				webui
			}
			properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
				nodes {
					id
					key
					value
					version {
						number
					}
				}
			}
			followingSiblings {
				nodes {
					id
					title
					status
					createdDate(format: MILLIS) {
						value
					}
					hasChildren
					blank
					hasRestrictions @include(if: $isSuperAdmin)
					hasInheritedRestrictions @include(if: $isSuperAdmin)
					type
					subType
					links {
						webui
					}
					properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
						nodes {
							id
							key
							value
							version {
								number
							}
						}
					}
				}
			}
		}
		rootLevelPages: pages(spaceKey: $spaceKey, status: $statuses)
			@skip(if: $isReplacePagesWithPTPageEnabled) {
			nodes {
				id
				title
				status
				hasChildren
				blank
				hasRestrictions @include(if: $isSuperAdmin)
				hasInheritedRestrictions @include(if: $isSuperAdmin)
				type
				links {
					webui
				}
				properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
			}
		}
		space(key: $spaceKey) {
			id
			homepage {
				id
			}
			operations {
				operation
				targetType
			}
		}
	}
`;

export const PageTreeWithSpaceKeyQuery = gql`
	query PageTreeWithSpaceKeyQuery(
		$spaceKey: String!
		$statuses: [GraphQLPageStatus]
		$ptStatuses: [PTGraphQLPageStatus]
		$paginationLimit: Int
		$isSuperAdmin: Boolean!
		$isReplacePagesWithPTPageEnabled: Boolean!
	) {
		space(key: $spaceKey) {
			id
			homepageId
			pageTree(pageTree: $paginationLimit, status: $ptStatuses, enablePaging: true) {
				id
				title
				status
				createdDate(format: MILLIS) {
					value
				}
				hasChildren
				blank
				hasRestrictions @include(if: $isSuperAdmin)
				hasInheritedRestrictions @include(if: $isSuperAdmin)
				type
				subType
				links {
					webui
				}
				properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				nearestAncestors {
					pageInfo {
						hasNextPage
						endCursor
					}
					nodes {
						id
						title
						status
						createdDate(format: MILLIS) {
							value
						}
						hasChildren
						blank
						hasRestrictions @include(if: $isSuperAdmin)
						hasInheritedRestrictions @include(if: $isSuperAdmin)
						type
						subType
						links {
							webui
						}
						properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
							nodes {
								id
								key
								value
								version {
									number
								}
							}
						}
						previousSiblings {
							nodes {
								id
								title
								status
								createdDate(format: MILLIS) {
									value
								}
								hasChildren
								blank
								hasRestrictions @include(if: $isSuperAdmin)
								hasInheritedRestrictions @include(if: $isSuperAdmin)
								type
								subType
								links {
									webui
								}
								properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
									nodes {
										id
										key
										value
										version {
											number
										}
									}
								}
							}
							pageInfo {
								hasNextPage
							}
						}
						followingSiblings {
							nodes {
								id
								title
								status
								createdDate(format: MILLIS) {
									value
								}
								hasChildren
								blank
								hasRestrictions @include(if: $isSuperAdmin)
								hasInheritedRestrictions @include(if: $isSuperAdmin)
								type
								subType
								links {
									webui
								}
								properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
									nodes {
										id
										key
										value
										version {
											number
										}
									}
								}
							}
							pageInfo {
								hasNextPage
							}
						}
					}
				}
				previousSiblings {
					nodes {
						id
						title
						status
						createdDate(format: MILLIS) {
							value
						}
						hasChildren
						blank
						hasRestrictions @include(if: $isSuperAdmin)
						hasInheritedRestrictions @include(if: $isSuperAdmin)
						type
						subType
						links {
							webui
						}
						properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
							nodes {
								id
								key
								value
								version {
									number
								}
							}
						}
					}
					pageInfo {
						hasNextPage
					}
				}
				followingSiblings {
					nodes {
						id
						title
						status
						createdDate(format: MILLIS) {
							value
						}
						hasChildren
						blank
						hasRestrictions @include(if: $isSuperAdmin)
						hasInheritedRestrictions @include(if: $isSuperAdmin)
						type
						subType
						links {
							webui
						}
						properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
							nodes {
								id
								key
								value
								version {
									number
								}
							}
						}
					}
					pageInfo {
						hasNextPage
					}
				}
				children {
					nodes {
						id
						title
						status
						createdDate(format: MILLIS) {
							value
						}
						hasChildren
						blank
						hasRestrictions @include(if: $isSuperAdmin)
						hasInheritedRestrictions @include(if: $isSuperAdmin)
						type
						subType
						links {
							webui
						}
						properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
							nodes {
								id
								key
								value
								version {
									number
								}
							}
						}
					}
					pageInfo {
						hasNextPage
					}
				}
			}
			operations {
				operation
				targetType
			}
		}
		ptpage(spaceKey: $spaceKey, status: $ptStatuses)
			@include(if: $isReplacePagesWithPTPageEnabled) {
			id
			title
			status
			createdDate(format: MILLIS) {
				value
			}
			hasChildren
			blank
			hasRestrictions @include(if: $isSuperAdmin)
			hasInheritedRestrictions @include(if: $isSuperAdmin)
			type
			subType
			links {
				webui
			}
			properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
				nodes {
					id
					key
					value
					version {
						number
					}
				}
			}
			followingSiblings {
				nodes {
					id
					title
					status
					createdDate(format: MILLIS) {
						value
					}
					hasChildren
					blank
					hasRestrictions @include(if: $isSuperAdmin)
					hasInheritedRestrictions @include(if: $isSuperAdmin)
					type
					subType
					links {
						webui
					}
					properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
						nodes {
							id
							key
							value
							version {
								number
							}
						}
					}
				}
			}
		}
		rootLevelPages: pages(spaceKey: $spaceKey, status: $statuses)
			@skip(if: $isReplacePagesWithPTPageEnabled) {
			nodes {
				id
				title
				status
				hasChildren
				blank
				hasRestrictions @include(if: $isSuperAdmin)
				hasInheritedRestrictions @include(if: $isSuperAdmin)
				type
				links {
					webui
				}
				properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
			}
		}
	}
`;
